<template>
  <div class="upload-container flex">
    <slot name="uploadView"></slot>
    <el-upload
      ref="upload"
      v-show="customStyle"
      action=""
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :on-error="handleError"
      :data="uploadParams"
      :headers="uploadHeaders"
      :on-change="handleChange"
      :auto-upload="false"
      :accept="allowedTypes"
    >
      <el-button class="upload-button" type="primary" plain style="width: 100px"
        >选择文件</el-button
      >
    </el-upload>
    <div class="file_tips" v-show="customStyle">
      <span>{{ uploadFiles ? uploadFiles.name : "请选择上传文件" }}</span>
      <span class="file_cancel" v-if="!!uploadFiles" @click="fileCancelHandle"
        ><i class="el-icon-close close"></i
      ></span>
    </div>
    <!-- 上传进度 -->
    <uploadProgress
      :visible="progressVisible"
      :title="progressTitle"
      :info="progressInfo"
      :successTitle="progressSuccessTitle"
      :progressPercent="progressPercent"
      :isUploadSuccess="isUploadSuccess"
      @successHandle="uploadProgressSuccess"
    ></uploadProgress>
  </div>
</template>

<script>
/*
    文件上传组件
    目前只支持单文件上传
    暂无预览（建议各处单独设置，开发）
    参数：
        immediateUpload            是否选择文件后立即上传 立即上传情况下uploadUrlChange直接返回文件url
        maxSize                    最大可上传文件大小  以M为单位
        allowedTypes               允许上传文件类型 ".mp3,.mp4"
        getTokenParams：{    获取sts临时凭证的参数   此参数必传
          type: 'school_course',   必传 school_course/school_topic
          partner_id: '',          根据type参数不同
          course_id: ''            根据type参数不同
        }
        useOriginalName            是否使用原文件名字
        progressAutoClose          大文件切片上传完成后，进度条自动隐藏，不展示成功页面
        
        uploadUrlChange            immediateUpload = false 时将文件名临时赋予文件上传地址参数，防止有必填验证阻止
        uploadClose                文件上传成功，且数据新增、编辑成功后调用的方法

        uploadStart                文件开始上传接口，返回文件完整地址 const url = await this.$refs.upload.uploadStart()
*/
import uploadProgress from "./uploadProgress.vue";
import api from "@/api/common.js";
export default {
  components: {
    uploadProgress,
  },
  props: {
    immediateUpload: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      defalt: 0,
    },
    allowedTypes: {
      type: String,
      defalt: "",
    },
    getTokenParams: {
      type: Object,
      default() {
        return {};
      },
    },
    useOriginalName: {
      type: Boolean,
      default: false,
    },
    progressAutoClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploader: null,
      uploadFiles: null,
      uploadParams: {},
      uploadHeaders: {},
      uploadInfo: {},
      fileTypeStr: "",
      progressVisible: false,
      progressPercent: 0,
      isUploadSuccess: false,
      customStyle: true,
      progressTitle: "",
      progressInfo: "",
      progressSuccessTitle: "",
      nowdate: "",
    };
  },
  mounted() {
    this.customStyle = !this.$slots.uploadView;
  },
  beforeDestroy() {
    this.uploader = null;
    this.uploadFiles = null;
  },
  methods: {
    //这里通过元素选择器来手动触发点击事件
    uploadFilesHandle() {
      this.$refs.upload.$el.querySelector(".upload-button").click();
    },
    // 上传成功后的处理
    handleSuccess(response, file, fileList) {
      console.log(file);
    },
    // 上传失败后的处理逻辑
    handleError(err, file, fileList) {
      console.log("上传失败", err);
    },
    beforeUpload(file) {
      console.log(file);
    },
    // 文件取消
    fileCancelHandle() {
      this.uploader = null;
      this.uploadFiles = null;
      this.$emit("uploadUrlChange", "");
    },
    async handleChange(file, fileList) {
      let pos = file.name.lastIndexOf(".");
      if (pos !== -1) {
        this.fileTypeStr = file.name.substring(pos);
      }
      if(this.allowedTypes && this.allowedTypes.indexOf(this.fileTypeStr) == -1) {
        this.$message.error("上传失败！请选择指定格式的文件。");
        return false
      }
      this.uploadFiles = file;
      console.log(file, "file....");
      if (!this.immediateUpload) {
        this.$emit("uploadUrlChange", file.name, file);
      } else {
        let url = await this.uploadStart();
        this.$emit("uploadUrlChange", url);
      }
    },
    uploadValidate() {
      return new Promise(async (resolve, reject) => {
        let maxSize = null;
        if (this.maxSize) {
          maxSize = this.maxSize * 1024 * 1024;
        } else {
          maxSize = this.uploadInfo.upload_max_filesize;
        }
        let fileSize = this.uploadFiles.size;
        if (fileSize > maxSize) {
          this.$message.error("上传失败！上传文件过大。");
          resolve(false);
        }
        resolve(true);
      });
    },
    uploadStart() {
      console.log("uploadStart....");
      return new Promise(async (resolve, reject) => {
        api.getUploadStsToken(this.getTokenParams).then(async (res) => {
          if (res.code === 0) {
            this.uploadParams = res.data.ak;
            this.uploadInfo = res.data.info;
            const validate = await this.uploadValidate();
            if (!validate){
              resolve(false)
              return false;
            }
            this.nowdate = Date.now();//当前时间戳
            let self = this;
            this.uploader = new OSS({
              bucket: self.uploadInfo.bucket,
              // 将<YOUR_REGION>设置为OSS Bucket所在地域，例如oss-cn-hangzhou。
              region: self.uploadInfo.region,
              accessKeyId: self.uploadParams.AccessKeyId,
              accessKeySecret: self.uploadParams.AccessKeySecret,
              stsToken: self.uploadParams.SecurityToken,
            });

            let result = null;
            if (this.uploadFiles.size > 10 * 1024 * 1024) {
              // 分片上传 断点续传（暂时搁置）
              // let uploadingList = await this.uploader.listUploads({ delimiter: '/' })
              // console.log(uploadingList)

              //上传地址
              let putUrl = "";

              if (this.useOriginalName) {
                putUrl =
                  this.uploadInfo.path +
                  "/" +
                  this.nowdate +
                  "/" +
                  this.uploadFiles.name;
              } else {
                putUrl = this.uploadInfo.full_path + this.fileTypeStr;
              }
              await this.uploader.multipartUpload(
                putUrl,
                this.uploadFiles.raw,
                {
                  // 获取分片上传进度、断点和返回值。
                  progress: (p, cpt, res) => {
                    // onUploadProgress&&onUploadProgress(p)
                    console.log(p, cpt, res);
                    this.progressVisible = true;
                    var num = Math.ceil(p * 100);
                    this.progressPercent = num;
                  },
                  // 设置并发上传的分片数量。
                  parallel: 4,
                  // 设置分片大小。默认值为1 MB，最小值为100 KB。
                  partSize: 10 * 1024 * 1024,
                  // headers,
                  // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
                  mime: "text/plain",
                  timeout: 120000, // 设置超时时间
                }
              ).then(res => {
                result = res
              }).catch(err => {});;
              if (this.immediateUpload) {
                this.uploadSuccess();
              }
              if (this.useOriginalName) {
                resolve(
                  this.uploadInfo.domain +
                    "/" +
                    this.uploadInfo.path +
                    "/" +
                    this.nowdate +
                    "/" +
                    this.uploadFiles.name
                );
              } else {
                resolve(
                  this.uploadInfo.domain +
                    "/" +
                    this.uploadInfo.full_path +
                    this.fileTypeStr
                );
              }
            } else {
              let loading = this.$loading({
                text: "文件上传中",
                spinner: "el-icon-loading", // 使用 Element UI 提供的加载图标
                background: "rgba(0, 0, 0, 0.7)", // 设置 loading 遮罩层背景色为半透明黑色
                target: document.querySelector("body"), // 将 loading 遮罩层挂载到页面 body 元素上
              });
              // loading会被遮挡
              setTimeout(() => {
                this.$nextTick(() => {
                  document.querySelector(".el-loading-mask").style.zIndex =
                    "999999";
                });
              });
              //上传地址
              let putUrl = "";
              if (this.useOriginalName) {
                putUrl =
                  this.uploadInfo.path +
                  "/" +
                  this.nowdate +
                  "/" +
                  this.uploadFiles.name;
              } else {
                putUrl = this.uploadInfo.full_path + this.fileTypeStr;
              }
              await this.uploader.put(putUrl, this.uploadFiles.raw).then(res => {
                result = res
              }).catch(err => {});
              loading.close();
              if (this.useOriginalName) {
                resolve(
                  this.uploadInfo.domain +
                    "/" +
                    this.uploadInfo.path +
                    "/" +
                    this.nowdate +
                    "/" +
                    this.uploadFiles.name
                );
              } else {
                resolve(
                  this.uploadInfo.domain +
                    "/" +
                    this.uploadInfo.full_path +
                    this.fileTypeStr
                );
              }
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 设置上传进度弹窗的文字title及info
    setProgressTitle(title, info) {
      this.progressTitle = title;
      this.progressInfo = info;
    },
    // 设置上传成功弹窗的title
    setProgressSuccessTitle(title) {
      this.progressSuccessTitle = title;
    },
    // 进度条成功弹窗 确定关闭
    uploadProgressSuccess() {
      this.progressVisible = false;
      this.isUploadSuccess = false;
      this.progressPercent = 0;
      this.$emit("uploadClose");
    },
    // 父组件调用的上传成功方法
    uploadSuccess() {
      if (this.progressAutoClose) {
        // 上传完成后进度条自动关闭
        this.progressVisible = false;
        this.isUploadSuccess = false;
        this.progressPercent = 0;
        this.$emit("uploadClose");
      } else {
        // 上传完成后进度条隐藏，展示上传成功弹窗
        this.progressVisible = true;
        this.isUploadSuccess = true;
        this.progressPercent = 0;
      }
      this.uploader = null;
      this.uploadFiles = null;
    },
  },
};
</script>

<style scoped lang='scss'>
.upload-container {
  .file_tips {
    color: #313131;
    font-size: 14px;
    margin-left: 9px;
    .file_cancel {
      width: 24px;
      height: 24px;
      line-height: 24px;
      background: #eff1ff;
      border-radius: 12px;
      color: #858ece;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      margin-left: 13px;
      .close {
        color: #858ece;
        font-size: 13px;
      }
      &:hover {
        background: #506bff;
        .close {
          color: #fff;
        }
      }
    }
  }
}
</style>
